import React, { useEffect } from 'react';
import { generalStore, playlistStore } from '../../store';
import PlaylistGroupContent from '../../components/playlistGroupContent/PlaylistGroupContent';
import Loader from '../../components/loader/Loader';
import { useParams } from 'react-router';
import type { PlaylistGroup } from '../../api/types';

const PlaylistGroupDetailView = () => {
    const { setLoading, loading } = generalStore();
    const { id: playlistGroupId } = useParams<{ id: string }>();
    const { getPlaylistGroup, selectedPlaylistGroup } = playlistStore();

    useEffect(() => {
        if (playlistGroupId) {
            getPlaylistGroup(playlistGroupId);
        }
        setLoading(false);
    }, [playlistGroupId]);

    if (!playlistGroupId || selectedPlaylistGroup.loading || loading || !selectedPlaylistGroup['@id']) {
        return <Loader loading={true} />;
    }

    const playlistGroup = selectedPlaylistGroup as unknown as PlaylistGroup;

    return (
        <div className="b-playlistContent-view">
            <PlaylistGroupContent
                playlistGroupId={playlistGroupId}
                playlistGroup={playlistGroup}
            />
        </div>
    );
};

export default PlaylistGroupDetailView;
